module.exports = __webpack_public_path__ + "static/media/HFCHS.1223f201.jpg";